import React from "react";

class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.state = {
      isLoaded: false,
      isMobile: false,
      isPlaying: false,
    };
  }

  componentDidMount() {
    this.detectMobile();
    this.setState({ isLoaded: true });
    window.addEventListener("resize", this.handleResize);

    // Initialize video after component mounts
    setTimeout(() => {
      this.initVideo();
    }, 500);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  detectMobile = () => {
    const isMobile =
      window.innerWidth <= 768 ||
      /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    this.setState({ isMobile });
  };

  initVideo = () => {
    const video = this.videoRef.current;
    if (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.setState({ isPlaying: true });
          })
          .catch(() => {
            this.setState({ isPlaying: false });
          });
      }
    }
  };

  toggleVideo = () => {
    const video = this.videoRef.current;
    if (video) {
      if (this.state.isPlaying) {
        video.pause();
        this.setState({ isPlaying: false });
      } else {
        video.play();
        this.setState({ isPlaying: true });
      }
    }
  };

  handleResize = () => {
    this.detectMobile();
    window.dispatchEvent(new Event("resize"));
  };

  render() {
    const { isLoaded, isMobile, isPlaying } = this.state;

    return (
      <div
        style={{
          position: "relative",
          height: "100vh",
          minHeight: "400px",
          width: "100%",
          overflow: "hidden",
          background: "#000",
        }}
      >
        {/* Video Background */}
        <video
          ref={this.videoRef}
          muted
          loop
          playsInline
          autoPlay
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.4,
            zIndex: 1,
          }}
        >
          <source
            src={`${process.env.PUBLIC_URL}/assets/media/video/video.mp4`}
            type="video/mp4"
          />
        </video>

        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            zIndex: 2,
          }}
        />

        {/* Content */}
        <div
          style={{
            position: "relative",
            zIndex: 3,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: isMobile ? "center" : "flex-start",
            padding: isMobile ? "20px" : "50px",
            textAlign: isMobile ? "center" : "left",
            paddingLeft: isMobile ? "20px" : "220px",
          }}
        >
          <h1
            style={{
              fontSize: isMobile ? "36px" : "72px",
              lineHeight: isMobile ? "46px" : "82px",
              fontWeight: 700,
              color: "#ffffff",
              margin: "0 0 20px 0",
              fontFamily: '"Poppins", sans-serif',
              textTransform: "uppercase",
              textShadow: "2px 2px 4px rgba(0,0,0,0.8)",
              maxWidth: isMobile ? "90%" : "700px",
            }}
          >
            Your Build Partner
          </h1>

          <p
            style={{
              fontSize: isMobile ? "14px" : "20px",
              lineHeight: isMobile ? "22px" : "28px",
              fontWeight: 500,
              color: "#ffffff",
              margin: "0 0 30px 0",
              fontFamily: '"Poppins", sans-serif',
              textShadow: "1px 1px 2px rgba(0,0,0,0.8)",
              maxWidth: isMobile ? "90%" : "600px",
            }}
          >
            Procure high-quality B2B raw materials for your construction Site
          </p>

          <a
            href="#about"
            style={{
              display: "inline-block",
              padding: isMobile ? "12px 25px" : "15px 35px",
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              color: "#000",
              textDecoration: "none",
              borderRadius: "5px",
              fontSize: isMobile ? "14px" : "16px",
              fontWeight: "600",
              textTransform: "uppercase",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
            }}
            onMouseEnter={e => {
              e.target.style.backgroundColor = "#000";
              e.target.style.color = "#fff";
              e.target.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={e => {
              e.target.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
              e.target.style.color = "#000";
              e.target.style.transform = "translateY(0)";
            }}
          >
            More About
          </a>
        </div>
      </div>
    );
  }
}

export default Slider;
